import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.unsplash.com',
    headers : {
        Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_SECRET}`,
        'Accept-Version' : 'v1'
    }
});
